<template>
  <div>
    <swiper class="homeSwiper" :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, index) in swiperList" :key="index">
        <a :href="item.link" target="_blank">
          <img
            style="display: block; margin: 0 auto"
            :src="item.coverImage"
            alt=""
            @click="goPath3(item)"
          />
        </a>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- 箭头 -->
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
    <div class="subTitle">{{$t("ProductCenter")}}</div>
    <div class="centerSwiper main">
      <div v-for="(item, index) in proList" :key="index">
        <div @click="goPath(item)">
          <img class="proImg" :src="item.icon" alt="" />
          <div class="imgTitle">
            <p>{{ item.name }}</p>
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 1200px; margin: 0 auto; padding: 0">
      <!-- <swiper :options="swiperOption1"
              ref="mySwiper"
              class="centerSwiper">
        <swiper-slide class="proSlide"
                      v-for="(item, index) in proList"
                      :key="index"
                      style="overflow: hidden;">
          <img class="proImg"
               :src="item.coverImage"
               alt="" />
          <div class="imgTitle">
            <p>{{item.tag}}</p>
            <b>{{item.name}}</b>
            <span></span>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev"
             slot="button-prev"><img src="../../assets/left.png"
               alt=""></div>
        <div class="swiper-button-next"
             slot="button-next"><img src="../../assets/right.png"
               alt=""></div>
      </swiper> -->
      <div class="subTitle">{{$t("IndustryApplication")}}</div>
      <div class="main apply" v-if='applyList.length'>
        <div style="width: 800px">
          <div class="ap ap0">
            <div class="be">
              <img :src="applyList[0].coverImage" alt="" />
              <p>{{ applyList[0].name }}</p>
              <div class="af">
                <p>{{ applyList[0].name }}</p>
                <span @click="goPath2(applyList[0])">{{$t("LearnMore")}}</span>
              </div>
            </div>
          </div>

          <div class="ap ap1">
            <div class="be">
              <img :src="applyList[1].coverImage" alt="" />
              <p>{{ applyList[1].name }}</p>
              <div class="af">
                <p>{{ applyList[1].name }}</p>
                <span @click="goPath2(applyList[1])">{{$t("LearnMore")}}</span>
              </div>
            </div>
          </div>
          <div class="ap ap2">
            <div class="be">
              <img :src="applyList[3].coverImage" alt="" />
              <p>{{ applyList[3].name }}</p>
              <div class="af">
                <p>{{ applyList[3].name }}</p>
                <span @click="goPath2(applyList[3])">{{$t("LearnMore")}}</span>
              </div>
            </div>
          </div>
          <div class="ap ap3">
            <div class="be">
              <img :src="applyList[4].coverImage" alt="" />
              <p>{{ applyList[4].name }}</p>
              <div class="af">
                <p>{{ applyList[4].name }}</p>
                <span @click="goPath2(applyList[4])">{{$t("LearnMore")}}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 400px">
          <div class="ap ap4">
            <div class="be">
              <img :src="applyList[2].coverImage" alt="" />
              <p>{{ applyList[2].name }}</p>
              <div class="af">
                <p>{{ applyList[2].name }}</p>
                <span @click="goPath2(applyList[2])">{{$t("LearnMore")}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="subTitle">{{$t("aboutUs")}}</div>
    </div>
    <div class="aboutus">
      <div class="main">
        <div style="width: 55%">
          <div class="description" v-html="form.content"></div>

          <!-- <p>
            士模微电子由国际知名专家领衔，以高性能ADC/DAC为技术核心，聚焦工业级和汽车级信号链芯片的设计和销售。产品线覆盖高精度和高速ADC、DAC、放大器、基准和LDO，为工业、能源、汽车和通信等领域提供高性能信号链产品解决方案。依托资深的研发、运营、质量、营销和客户支持团队，士模微电子坚持全正向设计并熟稔产品制造工艺，保障国产自主可控。
          </p> -->
          <!--         
        <p>士模微电子由国际知名专家领衔，专注于工业级信号链芯片的设计和销售，以高性能ADC/DAC芯片为技术核心，为客户提供丰富的信号链芯片产品以及SoC级解决方案。产品线全面覆盖高性能ΔΣ/SAR/Pipeline ADC、DAC、放大器、基准和LDO，并已导入高铁、电力、工控、仪器仪表等领域头部客户。
依托资深的研发、运营、质量、营销和客户支持团队，士模微电子坚持全正向设计并熟稔foundry工艺，保障国产自主可控，为客户提供高可靠高性能的产品和优质的服务。</p> -->
          <!-- <p>士模微电子专注于高性能模拟信号链芯片的设计和销售，以高性能ADC/DAC芯片为技术核心，聚焦工业自动化、能源、医疗、仪器仪表和汽车电子等领域，为客户提供丰富的信号链芯片产品以及SoC级解决方案。公司团队由国际知名专家领衔，并完整覆盖研发、运营、质量、营销和客户支持。目前公司高性能ADC/DAC、放大器、基准源、LDO等产品线已经实现产品量产，实测性能指标在同类产品中处于领先地位。
士模微电子将依托技术领先优势，为客户提供高可靠高性能的产品和优质的服务，成为国内高性能模拟信号链芯片行业先行者。</p> -->
          <!-- <p>
            北京士模微电子有限责任公司专注于高性能模拟信号链芯片的设计，旨在帮助工业，医疗，汽车等领域客户解决卡脖子难题。公司核心技术团队由相关领域国际知名专家牵头，清华、电子科大等院校的校友组成，团队技术实力出众。同时，公司运营团队也有着国内半导体领域15年以上的丰富产业化经验，为产业落地提供了充分的保障。目前公司高性能ADC/DAC产品线已经实现产品量产，实测性能指标在同类产品中处于领先地位。<br /><br />士模微电子将依托技术领先优势，不断加大技术投入，深耕国内市场，以高可靠高性能的产品和优质的服务，致力于成为国内高性能模拟信号链芯片行业先行者。
          </p> -->
          <a style="cursor: pointer" @click="pushUrl('/about', 0)">{{$t("LearnMore")}}</a>
        </div>
        <div class="div_box">
          <div v-if="languageCode=='zh'" class="second" @click="pushUrl('/introduce', 0)">
            <div class="box1"></div>
            <div class="box2">
              <p>{{$t("ContactUs")}}</p>
            </div>
            <div class="box3"></div>
          </div>
          <div class="first" @click="pushUrl('/about', 0)">
            <div class="box1"></div>
            <div class="box2">
              <p>{{$t("CompanyProfile")}}</p>
            </div>
            <div class="box3"></div>
          </div>
          <div class="third" @click="pushUrl('/about', 980)">
            <div class="box1"></div>
            <div class="box2">
              <p>{{$t("InvestmentPartners")}}</p>
            </div>
            <div class="box3"></div>
          </div>
         
        </div>
      </div>
    </div>
    <div style="background-color: #eeeeee; padding: 10px 0 90px 0" v-if="languageCode == 'zh'">
      <div class="subTitle">{{$t("NewsCenter")}}</div>
      <div class="main news">
        <div
          @click="goPath1(item)"
          class="subNew"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <div class="img_w">
            <img :src="item.coverImage" alt="" />
          </div>
          <div class="newsContent">
            <p>{{ item.title }}</p>
            <span v-if="item.description"
              >{{ item.description.slice(0, 40)
              }}<font v-if="item.description.length > 40">...</font></span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import {
  indexBannerList,
  getProductTree,
  getApplyList,
  getNewsList,
  getPromotionalVideo,
} from "@/api/index";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev"
        // }
      },
      swiperOption1: {
        loop: false,
        slidesPerView: 4.5,
        spaceBetween: 20,
        slidesPerGroup: 3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperList: [],
      proList: [],
      applyList: [],
      newsList: [],
      form:{},
      languageCode:'zh'

    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    const lang = this.$i18nState.locale;   // ✅ 正确的语言获取方式
    this.languageCode = lang
    getPromotionalVideo({languageCode:lang == 'zh'?'zh-CN':"en-US"}).then((res) => {
      this.form = res.data;
    });
    indexBannerList({languageCode:lang == 'zh'?'zh-CN':"en-US"}).then((res) => {
      this.swiperList = res.rows;
    });
    // 产品中心
    getProductTree({languageCode:lang == 'zh'?'zh-CN':"en-US"}).then((res) => {
      this.proList = res.data;
    });
    getApplyList({languageCode:lang == 'zh'?'zh-CN':"en-US"}).then((res) => {
      this.applyList = res.rows;
      console.log(this.applyList);
    });
    let params = {
      pageNum: 1,
      pageSize: 3,
      publishStatus: 1,
      category: 1,
    };
    getNewsList(params).then((res) => {
      this.newsList = res.rows;
    });
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    pushUrl(url, val) {
      const fullPath = this.getLocalizedPath(url);
      this.$router.push(fullPath);
      document.documentElement.scrollTop = val;
    },
    goPath(item) {
      const fullPath = this.getLocalizedPath("/product/index");
      this.$router.push({ path: fullPath, query: { id: item.id } });
      document.documentElement.scrollTop = 0;
    },
    goPath1(item) {
      const fullPath = this.getLocalizedPath("/newsDetail");
      this.$router.push({ path: fullPath, query: { id: item.id } });
      document.documentElement.scrollTop = 0;
    },
    goPath2(item) {
      const fullPath = this.getLocalizedPath("/apply");
      this.$router.push({ path: fullPath, query: { id: item.id } });
      document.documentElement.scrollTop = 0;
    },
    goPath3(item) {
    },
    // 获取带当前语言的完整路径
    getLocalizedPath(rawPath) {
      const currentLang = this.$i18nState.locale || "zh";
      // 如果路径已经以 /zh 或 /en 结尾，则直接返回
      if (/\/(zh|en)$/.test(rawPath)) {
        return rawPath;
      }
      // 移除路径末尾多余的斜杠，然后添加语言
      const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
      return `${base}/${currentLang}`;
    },
  },
  created() {
  // console.log('Home created, route:', this.$route.path)
  },
  beforeRouteEnter(to, from, next) {
    next()
  }
};
</script>
<style scoped lang="scss">
.homeSwiper {
  .swiper-main {
    width: 100%;
  }

  .swiper-container {
  }

  width: 100%;

  .swiper-container img {
    width: 100%;
  }
}

::v-deep .swiper-pagination-bullet-active {
  background-color: #b0352f;
}

::v-deep .swiper-pagination-bullet {
  width: 40px !important;
  height: 5px !important;
  border: none !important;
}

.imgTitle {
  position: absolute;
  // top: 0;
  width: 180px;
  bottom: 40px;

  p {
    font-size: 24px;
    color: #fff;
    padding-top: 192px;
    display: block;
    text-align: center;
    font-weight: bolder;
  }

  span {
    width: 70px;
    display: block;
    height: 2px;
    background: #fff;
    margin: 4px auto;
  }
}

.proSlide {
  position: relative;
}

.proSlide:hover .proImg {
  transform: scale(1.2, 1.2);
  transition: all 0.5s linear;
}

.apply {
  overflow: hidden;

  > div {
    overflow: hidden;
    float: left;
  }
}

.ap {
  position: relative;
  color: #fff;

  img {
    width: 100%;
    height: 100%;
  }

  .be {
    height: 100%;
    position: relative;
    > p {
      vertical-align: middle;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      font-size: 24px;
      color: #fff;
      font-weight: bold;
    }
  }

  .af {
    transform: scale(0, 0);
    transition: all 0.2s linear;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    background: rgba($color: #295f8d, $alpha: 0.3);

    p {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }

    span {
      display: block;
      width: 120px;
      height: 34px;
      text-align: center;
      line-height: 34px;
      background: #e5004f;
      margin: 20px auto;
      font-size: 18px;
      cursor: pointer;
    }
  }
}

.ap0 {
  width: 374px;
  height: 278px;
  float: left;
  margin: 0 10px 10px 0;

  .af p {
    margin-top: 24%;
  }
}

.ap1 {
  width: 404px;
  height: 278px;
  margin: 0 10px 10px 0;
  float: left;

  .af p {
    margin-top: 24%;
  }
}

.ap2 {
  width: 281px;
  height: 389px;
  margin: 0 10px 10px 0;
  float: left;

  .af p {
    margin-top: 50%;
  }
}

.ap3 {
  width: 496px;
  height: 389px;
  margin: 0 10px 10px 0;
  float: left;

  .af p {
    margin-top: 28%;
  }
}

.ap4 {
  height: 679px;
  margin: 0 10px 10px 0;
  float: left;

  .af p {
    margin-top: 64%;
  }
}

.ap:hover {
  .be {
    > p {
      display: none;
    }
  }

  .af {
    display: block;
    transform: scale(1, 1);
    transition: all 0.2s linear;
  }
}

.aboutus {
  height: 610px;
  overflow: hidden;
  background: url("../../assets/img11.png") no-repeat center;

  .main {
    overflow: hidden;
    padding: 80px 0;

    > div {
      float: left;
      height: 460px;
    }

    p {
      letter-spacing: 2px;
      font-size: 16px;
    }

    color: #fff;
    line-height: 34px;

    a {
      background: #e5004f;
      color: #fff;
      display: inline-block;
      padding: 2px 20px;
      margin-top: 40px;
    }
  }

  .div_box {
    background: url("../../assets/img12.png") no-repeat center;
    height: 100%;
    width: 45%;
    padding-left: 20px;
    box-sizing: border-box;
    background-size: 80%;
    position: relative;

    > div {
      position: absolute;
      transform: rotate(30deg);
      cursor: pointer;
    }

    > div:hover {
      // div{
      //   border-color: #d60e4c
      // }
      transition: all 0.3s ease-out 0s;

      .box1 {
        border-bottom: 30px solid #d60e4c;
      }

      .box3 {
        border-top: 30px solid #d60e4c;
      }

      .box2 {
        background-color: #d60e4c;
      }
    }

    p {
      transform: rotate(-30deg);
      line-height: 18px;
      padding:15px 0;
      text-align: center;
      font-weight: bold;
    }

    .first {
      right: 100px;
      top: 60px;
    }

    .second {
      right: 100px;
      bottom: 100px;
    }

    .third {
      left: 100px;
      bottom: 80px;
    }
  }
}

.news {
  overflow: hidden;

  .subNew {
    width: 33.3%;
    float: left;
    padding: 10px;
    box-sizing: border-box;
    height: 356px;
    cursor: pointer;
    .img_w {
      height: 240px;
      overflow: hidden;
    }

    img {
      width: 100%;
      transform: scale(1, 1);
      transition: all 0.2s linear;
    }

    img:hover {
      transform: scale(1.2, 1.2);
      transition: all 0.2s linear;
    }
  }
}

.newsContent {
  background: #fff url("../../assets/icon1.png") no-repeat right bottom;
  height: 120px;

  p {
    font-size: 20px;
    line-height: 40px;
    font-family: "MicrosoftYaHei";
    padding: 4px 24px 0 24px;
    margin-bottom: 2px;
    display: block;
    overflow: hidden; //超出文本隐藏
    text-overflow: ellipsis; ///超出部分省略号显示
    display: -webkit-box; //弹性盒模型
    -webkit-box-orient: vertical; //上下垂直
    -webkit-line-clamp: 1;
    font-weight: bolder;
  }

  span {
    display: block;
    overflow: hidden; //超出文本隐藏
    text-overflow: ellipsis; ///超出部分省略号显示
    display: -webkit-box; //弹性盒模型
    -webkit-box-orient: vertical; //上下垂直
    -webkit-line-clamp: 2;
    padding: 0 24px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    line-height: 22px;
    color: #4e4e4e;
    text-align: justify;
  }
}

.box1 {
  width: 0;
  border-left: 52px solid transparent;
  border-right: 52px solid transparent;
  border-bottom: 30px solid #0b4570;
}

.box2 {
  width: 104px;
  height: 60px;
  background-color: #0b4570;

  p {
    transform: rotate(-30deg);
    line-height: 58px;
    text-align: center;
  }
}
// .lang-en .div_box {
//   p{
//     line-height:30px;
//   }
// }
// .lang-en .box2 {
//   p{
//     line-height:30px;
//   }
// }

.box3 {
  width: 0;
  border-top: 30px solid #0b4570;
  border-left: 52px solid transparent;
  border-right: 52px solid transparent;
}

.centerSwiper {
  display: flex;

  > div {
    flex: 1;
    padding: 0 10px;
    position: relative;
    cursor: pointer;

    > div {
      overflow: hidden;
    }

    img {
      transform: scale(1, 1);
      transition: all 0.3s linear;
    }
  }

  > div:hover .proImg {
    transform: scale(1.2, 1.2);
    transition: all 0.5s linear;
  }
}
.description{
  font-size:18px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue